export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EspecialidadPage.vue?vue&type=template&id=47938dea&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/EspecialidadPage.vue?vue&type=template&id=47938dea&scoped=true&
// module id = 662
// module chunks = 2